var map = {
	"./level_1.svg": "8b6e",
	"./level_2.svg": "2049",
	"./level_3.svg": "42f9",
	"./level_4.svg": "3f65",
	"./level_5.svg": "f03f",
	"./level_6.svg": "322f",
	"./level_7.svg": "3e8e",
	"./level_8.svg": "e7de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9b3";